import { isSizeCompatible } from "./index67.js";
function canConsolidate(spaceA, spaceB, consolidationSpaces) {
  if (spaceA.attributes.requiredAvoid) {
    for (const typeToAvoid of spaceA.attributes.requiredAvoid) {
      if (spaceB.spaceType === typeToAvoid) {
        return -1;
      }
    }
  }
  if (spaceB.attributes.requiredAvoid) {
    for (const typeToAvoid of spaceB.attributes.requiredAvoid) {
      if (spaceA.spaceType === typeToAvoid) {
        return -1;
      }
    }
  }
  if (spaceA.consolidationType && spaceB.consolidationType) {
    return -1;
  }
  if (spaceA.spaceType && spaceB.spaceType) {
    const index = consolidationSpaces.findIndex((space) => space.attributes.consolidates.includes(spaceA.spaceType) && space.attributes.consolidates.includes(spaceB.spaceType));
    if (index !== -1) {
      const consolidationSpace = consolidationSpaces[index];
      const ignore = { y: !!consolidationSpace.attributes.sizeY, z: !!consolidationSpace.attributes.sizeZ };
      if (!isSizeCompatible(spaceA, spaceB, ignore)) {
        return -1;
      }
      return index;
    }
  }
  return -1;
}
export {
  canConsolidate
};
//# sourceMappingURL=index59.js.map
